export const generateUuid = (): string =>
  globalThis.crypto?.randomUUID?.() ??
  `tmp-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
